module.exports = "<div>\n\n  <v-snackbar :timeout=\"timeout\" v-for=\"(notification,index) in notifications\" :key=\"index\" v-model=\"notification.value\">\n\n    {{notification.text}}\n\n    <v-btn light flat class=\"orange--text\" @click.native=\"notification.value = false\">Close</v-btn>\n\n  </v-snackbar>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/plain/globalNotification/globalNotification.vue
// module id = 433
// module chunks = 0